import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
    
  async getSharedToHypeAssets(context, payload = {}) {
    try {
      let resp = await axios.get(`${Constants.hypePosts}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSharedToHypeAssets][Store][Error occured while getting shared assets info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  
  async getSocialMediaProfiles(context, payload = {}) {
    try {
      let resp = await axios.get(`${Constants.socialMediaProfilesUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSocialMediaProfiles][Store][Error occured while getting social media profiles--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getTagsAutocompleteFromServer(context, payload ={}){
    try {
      let resp = await axios.get(Constants.trendingTagsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getTagsAutocompleteFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        error.response.data.statusCode = error.response.status
        return error.response.data
      }
      return {}
    }
  },

  async getTrendingTagsFromServer(context, payload ={}){
    try {
      let resp = await axios.get(Constants.trendingTagsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getTrendingTagsFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        error.response.data.statusCode = error.response.status
        return error.response.data
      }
      return {}
    }
  },

  async socialMediaShareJob(context, payload ={}){
    try {
      let resp = await axios.post(`${Constants.jobsUrl}`, payload);
      console.log("The returned response is", resp)

          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              console.log(
                  `[socialMediaShareJob][Store][Posted request Status : -->${resp.status}]`
              );
              resp.data.statusCode = resp.status;
              return resp;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[socialMediaShareJob][Store][Error occured while sending mail--->${error}]`
          );
          if (error.response) {
              error.response.data.statusCode = error.response.status
              return error.response.data
          }
          return {}
      }
    },

    async getEnabledSocialMediaOptionsFromServerFromServer(context, payload ={}){
      try {
        let resp = await axios.get(Constants.hypeSocialMediaConfigUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
        }else {
          throw `getEnabledSocialMediaOptionsFromServerFromServer Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
      } catch (error) {
        console.error(
          `[getEnabledSocialMediaOptionsFromServerFromServer][Store][Error occured while getting userslist--->${error}]`
        );
        if (error.response) {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
        return {}
      }
    }, 
    
    async getHypeProfilesFromServer(context, payload ={}){
      try {
        let resp = await axios.get(Constants.hypeSocialMediaConfigUrl+"/profiles", payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
        }else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
      } catch (error) {
        console.error(
          `[getHypeProfilesFromServer][Store][Error occured while getting userslist--->${error}]`
        );
        if (error.response) {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
        return {}
      }
    },
  
};
